import { useState } from 'react'
import { Calendar, Cake } from 'lucide-react'
import Card from '../components/Card'
import Button from '../components/Button'

export default function AgeCalculator() {
  const [birthdate, setBirthdate] = useState('')
  const [result, setResult] = useState(null)

  const calculateAge = () => {
    if (!birthdate) {
      alert('Please select your birthdate')
      return
    }

    const birth = new Date(birthdate)
    const today = new Date()
    
    let years = today.getFullYear() - birth.getFullYear()
    let months = today.getMonth() - birth.getMonth()
    let days = today.getDate() - birth.getDate()

    if (days < 0) {
      months--
      const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0)
      days += lastMonth.getDate()
    }

    if (months < 0) {
      years--
      months += 12
    }

    // Calculate total days
    const diffTime = Math.abs(today - birth)
    const totalDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    const totalWeeks = Math.floor(totalDays / 7)
    const totalMonths = Math.floor(totalDays / 30.44)

    // Calculate next birthday
    const nextBirthday = new Date(today.getFullYear(), birth.getMonth(), birth.getDate())
    if (nextBirthday < today) {
      nextBirthday.setFullYear(today.getFullYear() + 1)
    }
    const daysUntilBirthday = Math.ceil((nextBirthday - today) / (1000 * 60 * 60 * 24))

    setResult({
      years,
      months,
      days,
      totalDays,
      totalWeeks,
      totalMonths,
      nextBirthday: nextBirthday.toLocaleDateString('en-US', { 
        weekday: 'long', 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      }),
      daysUntilBirthday
    })
  }

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="mb-6">
            <label className="block text-gray-700 font-semibold mb-3">Birthdate:</label>
            <input
              type="date"
              value={birthdate}
              onChange={(e) => setBirthdate(e.target.value)}
              className="input w-full"
              max={new Date().toISOString().split('T')[0]}
            />
          </div>

          <Button onClick={calculateAge} variant="primary" className="w-full">
            <Cake className="w-5 h-5 mr-2" />
            Calculate Age
          </Button>
        </Card.Body>
      </Card>

      {result && (
        <Card>
          <Card.Body>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Your Age:</h3>
                <div className="bg-orange-50 rounded-lg p-6 text-center">
                  <div className="text-4xl font-bold text-orange-600 mb-2">
                    {result.years} years, {result.months} months, {result.days} days
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Total Time:</h3>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  <div className="bg-gray-50 rounded-lg p-4 text-center">
                    <div className="text-2xl font-bold text-orange-600">{result.totalDays}</div>
                    <div className="text-sm text-gray-600 mt-1">Days</div>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4 text-center">
                    <div className="text-2xl font-bold text-orange-600">{result.totalWeeks}</div>
                    <div className="text-sm text-gray-600 mt-1">Weeks</div>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4 text-center">
                    <div className="text-2xl font-bold text-orange-600">{result.totalMonths}</div>
                    <div className="text-sm text-gray-600 mt-1">Months</div>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Next Birthday:</h3>
                <div className="bg-blue-50 rounded-lg p-4">
                  <div className="text-lg font-semibold text-blue-600 mb-2">{result.nextBirthday}</div>
                  <div className="text-sm text-gray-600">
                    {result.daysUntilBirthday} days remaining
                  </div>
                </div>
              </div>
            </div>
          </Card.Body>
        </Card>
      )}

      {!result && (
        <Card>
          <Card.Body className="text-center py-12">
            <Cake className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <p className="text-gray-600">Enter your birthdate and click "Calculate Age"</p>
          </Card.Body>
        </Card>
      )}
    </div>
  )
}

